import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col base-margin-right" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SIcon = _resolveComponent("SIcon")!
  const _component_q_item = _resolveComponent("q-item")!

  return (_openBlock(), _createBlock(_component_q_item, { class: "row items-center base-padding" }, {
    default: _withCtx(() => [
      _createVNode(_component_SIcon, {
        color: "brand",
        class: "col-auto base-margin-right",
        name: "app:drag"
      }),
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.item.label ? _ctx.item.label : 'Без заголовка'), 1),
      (_ctx.active)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_Transition, { name: "q-transition--scale" }, {
              default: _withCtx(() => [
                (_ctx.innerValue)
                  ? (_openBlock(), _createBlock(_component_SIcon, {
                      key: 0,
                      color: "brand",
                      name: "app:eye",
                      class: "cursor-pointer col-auto",
                      onClick: _ctx.toggle
                    }, null, 8, ["onClick"]))
                  : (_openBlock(), _createBlock(_component_SIcon, {
                      key: 1,
                      color: "brand",
                      name: "app:eye-close",
                      class: "cursor-pointer col-auto",
                      onClick: _ctx.toggle
                    }, null, 8, ["onClick"]))
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}